
















































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { AlteracaoDaLoja } from '@/shareds/nova-edicao-de-loja/alteracoes'
import { IdDaSecao, SECAO_POR_ID } from '@/shareds/nova-edicao-de-loja/secoes'

@Component
export default class BarraDeSalvarDaLoja extends Vue {
	@Prop({ type: Array, default: () => [] }) alteracoes!: AlteracaoDaLoja[]
	@Prop({ type: Boolean, default: false }) salvando!: boolean
	@Prop({ type: Boolean, default: true }) podeEditar!: boolean
	@Prop({ type: Boolean, default: false }) novo!: boolean

	get resumo() {
		const titulos = this.alteracoes.map(({ titulo }) => titulo)
		if (titulos.length <= 2) return titulos.join('; ')
		return `${titulos.slice(0, 2).join('; ')} e mais ${titulos.length - 2}`
	}

	tituloDaSecao(secao: IdDaSecao) {
		return SECAO_POR_ID[secao] ? SECAO_POR_ID[secao].titulo : ''
	}
}
